import { options2Map } from '@common/oneclub/utils/options2map'

// 产品类型
export enum PRODUCT {
  oneship = 'ONESHIP',
  oneWarehouse = 'ONEWAREHOUSE',
  oneCargo = 'ONECARGO',
  all = 'ALL',
}

export const ProductOptions = [
  {
    value: PRODUCT.oneship,
    label: 'OneShip',
  },
  {
    value: PRODUCT.oneWarehouse,
    label: 'OneWarehouse',
  },
]

export const ProductMap = options2Map(ProductOptions, 'value', 'label')
